<template>
  <div class="video-box-logo-container">
    <img
      class="video-box-logo"
      :class="getLogoWidth"
      :style="[getCustomContentWidth]"
      :alt="content.alt_text"
      :title="content.title_text"
      :src="content.image_url"
    >
  </div>
</template>
<script>
export default {
  name: 'banner-graphic',
  props: {
    content: {
      type: Object,
      required: true
    },
    contentWidth: {
      type: String,
      default: 'small',
      required: false,
      validator: (string) => string.length > 0
    }
  },
  computed: {
    // return the logo size chosen
    getLogoWidth() {
      if (this.content.image_size != null && this.content.image_size) {
        return `video-box-logo-size-${this.content.image_size}`
      }
      return null
    },
    // if custom is chosen,
    // we return the inline style for the dynamic sizing of the logo,
    // percent based relative to the parent container this component is added to.
    getCustomContentWidth() {
      if (this.content.image_size === 'custom') {
        return {
          '--content-custom-width': this.content.image_size_custom_width + '%' // css variables used instead of straight inline style values here for great control in styling
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@scss/custom.scss";

.video-box-logo-container {
  width: 100%;
  display: flex;
  flex: 1;
  align-items: inherit;
  justify-content: inherit;
  --vc-video-box-logo-size: 15em;

  .video-box-logo {
    display: flex;
    flex: 1;
    object-fit: contain;
    --vc-video-box-logo-size-display: calc(var(--vc-video-box-logo-size) * 0.5);

    @include media-breakpoint-up(md) {
      --vc-video-box-logo-size-display: calc(
        var(--vc-video-box-logo-size) * 0.75
      );
    }
    @include media-breakpoint-up(lg) {
      --vc-video-box-logo-size-display: calc(var(--vc-video-box-logo-size) * 1);
    }
    @include media-breakpoint-up(xl) {
      --vc-video-box-logo-size-display: calc(
        var(--vc-video-box-logo-size) * 1.2
      );
    }
  }
  .video-box-logo-size {
    &-small {
      width: var(--vc-video-box-logo-size-display);
      max-width: var(--vc-video-box-logo-size-display);
    }
    &-medium {
      width: calc(var(--vc-video-box-logo-size-display) * 1.25);
      max-width: calc(var(--vc-video-box-logo-size-display) * 1.25);
    }
    &-large {
      width: calc(var(--vc-video-box-logo-size-display) * 1.75);
      max-width: calc(var(--vc-video-box-logo-size-display) * 1.75);
    }
    &-custom {
      width: var(--content-custom-width);
      max-width: var(--content-custom-width);
    }
  }
}
</style>
